export function composeSpawn({ roomNum, variantId = null, rng }) {
  // Progressive scaling: room 1 starts at 2 enemies, then +1 each room.
  // Boss rooms are handled separately in Game._spawnEnemiesForRoom.
  const total = Math.max(2, roomNum + 1);
  const progress = Math.min(1, (roomNum - 1) / 8);

  // Shift composition from drone-heavy early to mixed later rooms.
  const zealotTarget = Math.floor(total * (0.12 + progress * 0.28));
  const enforcerTarget = Math.floor(total * (0.22 + progress * 0.2));

  let zealots = Math.min(zealotTarget, total);
  let enforcers = Math.min(enforcerTarget, total - zealots);
  let drones = Math.max(0, total - enforcers - zealots);
  let minmons = 0;
  let ziluas = 0;

  // Stage 3 tuning: reduce Enforcer pressure by ~40% only on this stage.
  if (roomNum === 3 && enforcers > 0) {
    const reduced = Math.floor(enforcers * 0.6);
    const removed = Math.max(0, enforcers - reduced);
    enforcers = reduced;
    drones += removed;
  }

  // Ensure at least one drone in early game readability.
  if (roomNum <= 3 && drones === 0) {
    if (enforcers > zealots && enforcers > 0) enforcers--;
    else if (zealots > 0) zealots--;
    drones = 1;
  }

  // Variant identity tweaks:
  // A balanced: baseline curve.
  // B tight/close: move pressure from drones to close-range enemies.
  // C open: emphasize ranged/mobility threats with fewer bruisers.
  if (variantId === 'B') {
    if (drones > 0) { drones--; enforcers++; }
    if (roomNum >= 4 && enforcers > 0) { enforcers--; zealots++; }
  } else if (variantId === 'C') {
    if (enforcers > 0) { enforcers--; drones++; }
  }

  // New enemy spice appears gradually:
  // - Minmon enter first as fast swarm pressure.
  // - Zilua stay uncommon and more likely in open rooms.
  if (roomNum >= 3) {
    minmons = 1 + Math.floor(progress * 1.6);
    if (variantId === 'B' && roomNum >= 4) minmons++;
  }
  const ziluaChance = 0.06 + progress * 0.24 + (variantId === 'C' ? 0.08 : 0);
  if (roomNum >= 4 && rng() < ziluaChance) {
    ziluas = 1;
    if (roomNum >= 8 && rng() < 0.2) ziluas = 2;
  }

  const replacements = minmons + ziluas;
  for (let i = 0; i < replacements; i++) {
    if (drones >= enforcers && drones >= zealots && drones > 0) drones--;
    else if (enforcers >= zealots && enforcers > 0) enforcers--;
    else if (zealots > 0) zealots--;
    else if (drones > 0) drones--;
  }

  return { drones, enforcers, zealots, minmons, ziluas };
}
